import { render, staticRenderFns } from "./_specification_tr.vue?vue&type=template&id=9f6a1a3c"
import script from "./_specification_tr.vue?vue&type=script&lang=js"
export * from "./_specification_tr.vue?vue&type=script&lang=js"
import style0 from "./_specification_tr.vue?vue&type=style&index=0&id=9f6a1a3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports